import { getPaginatorIntl } from './_helpers/paginator.translate';
const ɵ0 = getPaginatorIntl();
// class OwlDateTimeIntlPl extends OwlDateTimeIntl {
//   upSecondLabel = 'Add a second';
//   downSecondLabel = 'Minus a second';
//   upMinuteLabel = 'Add a minute';
//   downMinuteLabel = 'Minus a minute';
//   upHourLabel = 'Add a hour';
//   downHourLabel = 'Minus a hour';
//   prevMonthLabel = 'Previous month';
//   nextMonthLabel = 'Next month';
//   prevYearLabel = 'Previous year';
//   nextYearLabel = 'Next year';
//   prevMultiYearLabel = 'Previous 21 years';
//   nextMultiYearLabel = 'Next 21 years';
//   switchToMonthViewLabel = 'Change to month view';
//   switchToMultiYearViewLabel = 'Choose month and year';
//   cancelBtnLabel = 'Anuluj';
//   setBtnLabel = 'Ustaw';
//   rangeFromLabel = 'Od';
//   rangeToLabel = 'Do';
//   hour12AMLabel = 'AM';
//   hour12PMLabel = 'PM';
// }
/**
 * NgModule that includes all Material modules that are required to serve the demo-app.
 */
export class CustomMaterialModule {
}
export { ɵ0 };
